<template>
    <div>
        <app-sub-title :text="`Gestión documental`" />
        <b-row>
            <b-col>
                <b-button
                    variant="primary"
                    @click="openPopupSaveFile"
                    class="btn-block-xs-only"
                >
                    <i class="fa fa-plus"></i> Subir documento
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-file-management-filters
                    @filter="onFilter"
                ></app-file-management-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-file-management-list
                    :data="data"
                    @change-page="changePage"
                    @update-file="startUpdate"
                    @remove-file="startRemove"
                    @sort="onSort"
                />
            </b-col>
        </b-row>

        <app-pop-up
            title="Formulario para subir archivos"
            id="file-form"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <app-file-management-form
                    @onSave="onSave"
                    @onError="onError"
                    ref="management-form"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="saveFile"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <!-- fin de pop up's -->
    </div>
</template>

<script>
import FileManagementFilters from '../../Administrative/FileManagement/FileManagementFilters'
import FileManagementForm from '../../Administrative/FileManagement/FileManagementForm'
import FileManagementList from '../../Administrative/FileManagement/FileManagementList'
export default {
    components: {
        appFileManagementForm: FileManagementForm,
        appFileManagementList: FileManagementList,
        appFileManagementFilters: FileManagementFilters,
    },
    data() {
        return {
            data: [],
            page: 1,
            selectVenue: '',
            filters: {},
            sort: {
                sortBy: 'name',
                sortDir: 'asc',
            },
        }
    },
    methods: {
        onFilter(filters) {
            this.filters = filters
            this.loadFiles()
        },
        async loadFiles() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                clientId: this.client.id,
            }

            const { data } = await repo.get(
                'file-management',
                filters,
                'Lo sentimos, ha ocurrido un error'
            )
            this.data = data
        },
        changePage(page) {
            this.page = page
            this.loadFiles()
        },
        openPopupSaveFile() {
            this.$refs['management-form'].cleanForm()
            this.$bus.$emit('file-form.open')
        },
        saveFile() {
            this.$refs['management-form'].saveFile()
        },
        onSave(data) {
            this.$bus.$emit('file-form.close')
            this.$refs['management-form'].cleanForm()
            toastr.success(data.msg)
            this.loadFiles()
        },
        onError(data) {
            this.$bus.$emit('file-form.close')
            toastr.error(data.msg)
        },
        cleanForm() {
            this.$bus.$emit('file-form.clean')
        },
        startUpdate(file) {
            this.$refs['management-form'].fillForm(file)
            this.$bus.$emit('file-form.open')
        },
        async startRemove(id) {
            const { data } = await repo.delete(`file-management/${id}`)
            if (data.status) {
                toastr.success(data.msg)
                this.loadFiles()
            } else {
                toastr.error(data.msg)
            }
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadFiles()
        },
    },
    created() {
        this.loadFiles()
    },
}
</script>

<style></style>
